<template>
  <div>
    <div class="header">保函网-保函验证查询系统</div>
  <div class="content">
    
            <div class="home-top">
                <div class="system-title">
                    <div class="magnifier-icon">
                        <img src="../assets/magnifier.png">
                    </div>
                    <div class="title">保函验证查询系统</div>
                    <div class="explain">可通过本系统对您所开保函信息进行验证查询</div>
                </div>
                <div class="form-box">
                    <div class="level-item">
                        <div class="key">保函条码：</div>
                        <div class="input-text">
                            <input type="text" placeholder="请输入保函条码" v-model="bhtm" name="GuarateeCode" id="GuarateeCode" value="">
                        </div>
                    </div>
                    <div class="level-item">
                        <div class="key">防伪码：</div>
                        <div class="input-text">
                            <input type="text" placeholder="请输入防伪码" v-model="fwm" name="SecurityCode" id="SecurityCode" value="">
                        </div>
                    </div>
                    <div class="level-item submit-box">
                      <el-button class="submit" type="primary" :loading="showYzLoading" @click="checkSearch()">验证</el-button>
                    </div>
             
                </div>
            </div>
            <div class="query-method">
                <div class="method-box">
                    <div class="take-care">
                        <p class="title">保函查验形分为两种：</p>
                        <p>【第一种二维码查验】通过微信扫描保函右上角二维码查验  </p>
                        <p>【第二种防伪码查验】通过保函条码及防伪码在当前页面查验。</p>
                    </div>
                    <div class="hd">防伪码查验方法</div>
                    <div class="bd">
                        <ul>
                            <li>1.保函条码共计  <span class="blue">15</span> 位，为字母和数字组合。例如：<span class="orange">YSBH20200401483</span></li>
                            <li>2.防伪码共计  <span class="blue">6</span> 位，为字母和数字组合。例如：<span class="orange">9POLPI</span></li>
                        </ul>
                        <div class="tip">注：查询时条码与防伪码不区分大小写。</div>
                    </div>
                </div>
            </div>
        
  </div>
  <div class="foot">保函网<a href="https://www.beianx.cn/info/304539536511045" target="_blank">晋ICP备2022004459号</a></div>
  </div>
</template>

<script>
import {searchBhApi,getBhInfoApi} from "@/api/http"
export default {
 
  data () {
    return {
      showYzLoading:false,
      bhtm: '',
      fwm:''
    }
  },
  mounted:function(){

  },
  methods:{
    checkSearch:function(e){
      if(!this.bhtm){
        this.$message('请输入保函条码!');
        return;
      }
      if(!this.fwm){
        this.$message('请输入防伪码!');
        return;
      }
      this.showYzLoading = true;
      console.log(this.bhtm);
      let param = {
        bh_code_tm:this.bhtm,
        bh_code_fwm:this.fwm
      }
      var that = this;
      searchBhApi(param).then(res=>{
        console.log(res)
        that.showYzLoading = false;
        if(!res){
          that.$message.error('查询不到保函信息!');
          return;
        }
               this.$router.push({name:'Detail',query:{bhCode:res.bh_code}})

      })
    }
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header{
  position: fixed;
right: 0;
top: 0;
left: 0;
height: 45px;
line-height: 45px;
background: #2c2e31;
color: white;
border-top: 1px solid #ddd;
text-align: center;
box-shadow: 0 0 4px 1px #dcdcdc;
z-index: 999;
}
.foot{
  position: fixed;
right: 0;
bottom: 0;
left: 0;
height: 45px;
line-height: 45px;
background: #ffffff;
border-top: 1px solid #ddd;
text-align: center;
box-shadow: 0 0 4px 1px #dcdcdc;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%
}

body {
    margin: 0;
    padding: 0;font-family:'Microsoft YaHei';
}

ul,ol,li,dl,dt,dd,h1,h2,h3,h4,h5,h6,hgroup,p,blockquote,figure,form,fieldset,input,legend,pre,abbr,button {
    margin: 0;
    padding: 0
}

ul{ list-style: none;}

pre,code,address,caption,th,figcaption {
    font-size: 1em;
    font-weight: normal;
    font-style: normal
}

fieldset,iframe,img {
    border: 0
}

caption,th {
    text-align: left
}

table {
    border-collapse: collapse;
    border-spacing: 0
}

article,aside,footer,header,nav,main,section,summary,details,hgroup,figure,figcaption {
    display: block
}

audio,canvas,video,progress {
    display: inline-block;
    vertical-align: baseline
}

button {
    background: none;
    border: 0;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    color: inherit;
    cursor: pointer;
    font: inherit;
    line-height: inherit;
    overflow: visible;
    vertical-align: inherit
}

input,textarea,select,input:focus,button,button:focus {
    outline: none;
}

button:disabled {
    cursor: default
}

:focus {
    outline: 3px solid #c1e0fe;
    outline: 3px solid rgba(131,192,253,0.5);
    outline-offset: 1px
}

:focus[data-focus-method="mouse"]:not(input):not(textarea):not(select),:focus[data-focus-method="touch"]:not(input):not(textarea):not(select) {
    outline: none
}

::-moz-focus-inner {
    border: 0;
    padding: 0
}

/*color*/
.blue{ color:#0666e1 ;}
.orange{ color: #fc8800 ;}

.head{ height: 60px; background: #2c2e31;}
.head .centre{ width: 1100px; margin: 0 auto;}

.content{ width: 800px; margin: 0 auto; padding-top: 80px;}
.content .home-top{ padding: 0 100px; width: 600px;}
.system-title{ height: 150px; position: relative; padding-left: 200px;}

.magnifier-icon{ position: absolute; top: 0; left: 0;}
.system-title .title{ padding-top: 10px; line-height: 60px; font-weight: bold; color:#5c626b;; font-size: 40px;}
.system-title .explain{ color: #d89d58; font-size: 16px;}

.form-box .level-item{ position: relative; margin-top: 30px; min-height: 40px; padding-left: 100px;}
.form-box .level-item .key{ position: absolute; width: 100px; left: 0; top: 0; line-height: 40px; color: #666666;}
.form-box .input-text input{ padding: 0 10px; box-sizing: border-box; width: 100%; height: 40px; line-height: 40px; background: #f7f7f7; border: 1px solid #eeeeee; border-radius:6px;}
.form-box  .submit-box{ text-align: center;}
.form-box  .submit{ margin: 0 auto; width: 200px; height: 40px; border-radius: 6px; background: #ebcb30; color: #ffffff;}
.tip{ font-size: 14px; padding-top: 10px; color: #161716;}

.query-method{ padding-top: 40px; padding-bottom: 100px;}
.query-method .take-care{ line-height: 22px; color:#101010;}
.query-method .take-care .title{ font-weight: bold; color: #333;}
.query-method .take-care p{ padding: 5px 0; text-indent: -10em; padding-left: 10em;}
.method-box{ padding:20px 30px 30px; background: #b7b8b9;; border: 1px solid #7d8288;border-radius: 6px;}
.method-box .hd{ height: 40px; line-height: 40px; font-size: 16px; font-weight: bold; color: #333;}
.method-box li{ line-height: 30px; color:#1f1e1e;}

.detail{ width: 1100px; margin: 0 auto;}
.detail .code-list{ padding-bottom: 20px; padding-top: 45px; line-height: 40px; border-bottom: 1px solid #DCDCDC;}
.detail .code-list ul::after{ content:'';display: table; clear: both;}
.detail .code-list li{ float: left; padding-right: 30px;}
.detail .continue{float: right; width: 120px; height: 40px; border-radius: 6px; background: #0666e1; color: #ffffff;}
.detail .jsondata{padding:0 40px;}
.detail .jsondata li{ position: relative; padding: 10px 0 10px 160px; line-height: 30px; min-height: 30px;}
.detail .jsondata li .key{ position: absolute; left: 0; top: 0; padding: 10px 0; display: inline-block; width: 150px; text-align: right; color: #999;}
.detail .jsondata li .val{min-height: 30px;}
.detail  .remark{padding: 40px;}


.foot{ position: fixed; right: 0; bottom: 0; left: 0; height: 45px; line-height: 45px; background: #ffffff;border-top: 1px solid #ddd; text-align: center; box-shadow: 0 0 4px 1px #dcdcdc;}


</style>



// WEBPACK FOOTER //
// src/components/Home.vue